import {
  LayoutDashboard, Wallet, TestTube, CreditCard,
  ArrowLeftRight, BarChart3, Store, Copy, Zap, Layers, UserPlus,
  Coins, FileText, TrendingUp, ShoppingCart, DollarSign,
  Megaphone, Crown, Gift, Users, Shield, Target,
  ShieldCheck, Settings, LifeBuoy, Code,
  Globe, ArrowUpDown, Award, Rocket, Clock, CandlestickChart,
  Trophy,
  ClipboardList, History, Repeat, Banknote, ArrowDownToLine, ArrowUpFromLine,
  CreditCard as CreditCardIcon,
} from "lucide-react";

import type { LucideIcon } from "lucide-react";

export interface SidebarItem {
  to: string;
  label: string;
  icon: LucideIcon;
  moduleKey?: string;
  oldMemberOnly?: boolean;
  children?: SidebarItem[];
}

export interface SidebarGroupDef {
  key: string;
  label: string;
  icon: LucideIcon;
  items: SidebarItem[];
}

export const sidebarGroups: SidebarGroupDef[] = [
  {
    key: "portfolio",
    label: "Assets",
    icon: Wallet,
    items: [
      { to: "/app/wallets", label: "Wallets", icon: Wallet, moduleKey: "wallets" },
      { to: "/app/deposits", label: "Deposit Status", icon: ArrowDownToLine, moduleKey: "wallets" },
      { to: "/app/demo-wallet", label: "Demo Wallet", icon: TestTube, moduleKey: "demo_trading" },
      { to: "/app/cards", label: "Cards", icon: CreditCard, moduleKey: "virtual_cards" },
    ],
  },
  {
    key: "trade",
    label: "Trade",
    icon: BarChart3,
    items: [
      { to: "/app/markets", label: "All Markets", icon: CandlestickChart, moduleKey: "landing_markets" },
      { to: "/app/exchange", label: "Exchange", icon: ArrowLeftRight, moduleKey: "wallets" },
      {
        to: "/app/spot", label: "Spot", icon: BarChart3, moduleKey: "spot_trading",
        children: [
          { to: "/app/spot", label: "Markets", icon: BarChart3, moduleKey: "spot_trading" },
        ],
      },
      {
        to: "/app/futures", label: "Futures", icon: TrendingUp, moduleKey: "futures",
        children: [
          { to: "/app/futures", label: "Markets", icon: BarChart3, moduleKey: "futures" },
          { to: "/app/futures/wallets", label: "Wallets", icon: Wallet, moduleKey: "futures" },
        ],
      },
      {
        to: "/app/p2p", label: "P2P", icon: Store, moduleKey: "p2p",
        children: [
          { to: "/app/p2p/express", label: "Express", icon: Zap, moduleKey: "p2p" },
          { to: "/app/p2p/block", label: "Block", icon: Layers, moduleKey: "p2p" },
          { to: "/app/p2p/center", label: "P2P Center", icon: UserPlus, moduleKey: "p2p" },
        ],
      },
      {
        to: "/app/wallets?tab=fiat", label: "Fiat", icon: Banknote, moduleKey: "wallets",
        children: [
          { to: "/app/wallets?tab=fiat", label: "Wallets", icon: Wallet, moduleKey: "wallets" },
          { to: "/app/fiat/deposit", label: "Deposit", icon: ArrowDownToLine, moduleKey: "wallets" },
          { to: "/app/fiat/withdraw", label: "Withdraw", icon: ArrowUpFromLine, moduleKey: "wallets" },
        ],
      },

      {
        to: "/app/copy-trading", label: "Copy Trading", icon: Copy, moduleKey: "copy_trading",
        children: [
          { to: "/app/copy-trading", label: "Marketplace", icon: Store, moduleKey: "copy_trading" },
          { to: "/app/copy-trading/dashboard", label: "Dashboard", icon: LayoutDashboard, moduleKey: "copy_trading" },
        ],
      },
      { to: "/app/binary", label: "Binary", icon: Clock, moduleKey: "binary_trading" },
    ],
  },
  {
    key: "orders",
    label: "Orders",
    icon: ClipboardList,
    items: [
      { to: "/app/orders/assets-history", label: "Assets History", icon: History },
      { to: "/app/orders/spot", label: "Spot Order", icon: BarChart3, moduleKey: "spot_trading" },
      { to: "/app/orders/futures", label: "Futures Order", icon: TrendingUp, moduleKey: "futures" },
      { to: "/app/orders/margin", label: "Margin Order", icon: Layers, moduleKey: "margin" },
      { to: "/app/orders/p2p", label: "P2P Order", icon: Store, moduleKey: "p2p" },
      { to: "/app/orders/earn", label: "Earn History", icon: Coins, moduleKey: "earn" },
      { to: "/app/orders/fiat", label: "Fiat Order", icon: DollarSign, moduleKey: "fiat" },
      { to: "/app/orders/convert", label: "Convert History", icon: Repeat },
      { to: "/app/orders/payments", label: "Payment History", icon: CreditCardIcon, moduleKey: "virtual_cards" },
    ],
  },
  {
    key: "web3",
    label: "Web3 Hub",
    icon: Globe,
    items: [
      { to: "/app/web3", label: "Portfolio", icon: Globe, moduleKey: "web3_hub" },
      { to: "/app/web3/swap", label: "Swap", icon: ArrowUpDown, moduleKey: "web3_hub" },
      { to: "/app/web3/earn", label: "Earn", icon: TrendingUp, moduleKey: "web3_hub" },
      { to: "/app/web3/quests", label: "Quests", icon: Target, moduleKey: "web3_hub" },
      { to: "/app/web3/launchpad", label: "Launchpad", icon: Rocket, moduleKey: "web3_hub" },
      { to: "/app/web3/badges", label: "Badges", icon: Award, moduleKey: "web3_hub" },
      { to: "/app/web3/wallets", label: "Wallets", icon: Wallet, moduleKey: "web3_hub" },
    ],
  },
  {
    key: "earn",
    label: "Earn",
    icon: Coins,
    items: [
      { to: "/app/earn", label: "Earn Projects", icon: Coins, moduleKey: "earn" },
      {
        to: "/app/staking", label: "Staking", icon: Layers, moduleKey: "staking",
        children: [
          { to: "/app/staking", label: "Plans", icon: Layers, moduleKey: "staking" },
          { to: "/app/staking/positions", label: "Positions", icon: FileText, moduleKey: "staking" },
        ],
      },
      {
        to: "/app/token-sale", label: "Launchpad", icon: Rocket, moduleKey: "token_sale",
        children: [
          { to: "/app/token-sale", label: "Projects", icon: Rocket, moduleKey: "token_sale" },
          { to: "/app/token-sale/portfolio", label: "My Allocations", icon: Wallet, moduleKey: "token_sale" },
        ],
      },
      { to: "/app/my-stakings", label: "My Stakings", icon: FileText, moduleKey: "legacy_notes", oldMemberOnly: true },
      { to: "/app/notes-market", label: "Notes Market", icon: Store, moduleKey: "legacy_notes" },
      { to: "/app/my-notes", label: "My Notes", icon: FileText, moduleKey: "legacy_notes" },
    ],
  },
  {
    key: "growth",
    label: "Growth",
    icon: Megaphone,
    items: [
      {
        to: "/app/marketer", label: "Marketer HQ", icon: Megaphone, moduleKey: "referrals",
        children: [
          { to: "/app/marketer/tasks", label: "Content Tasks", icon: Target, moduleKey: "referrals" },
          { to: "/app/marketer/rewards", label: "Rewards", icon: Gift, moduleKey: "referrals" },
          { to: "/app/marketer/training", label: "Training", icon: FileText, moduleKey: "referrals" },
        ],
      },
      { to: "/app/creator-program", label: "Creator Program", icon: Target, moduleKey: "referrals" },
      {
        to: "/app/ambassador", label: "Ambassador HQ", icon: Crown, moduleKey: "referrals",
        children: [
          { to: "/app/ambassador/campaigns", label: "Campaigns", icon: Megaphone, moduleKey: "referrals" },
          { to: "/app/ambassador/community", label: "Community", icon: Users, moduleKey: "referrals" },
          { to: "/app/ambassador/reports", label: "Reports", icon: Shield, moduleKey: "referrals" },
          { to: "/app/ambassador/rewards", label: "Rewards", icon: Gift, moduleKey: "referrals" },
          { to: "/app/ambassador/analytics", label: "Analytics", icon: BarChart3, moduleKey: "referrals" },
        ],
      },
      {
        to: "/app/referrals", label: "Referrals", icon: Gift, moduleKey: "referrals",
        children: [
          { to: "/app/referrals", label: "Overview", icon: Gift, moduleKey: "referrals" },
          { to: "/app/referrals/earnings", label: "Earnings", icon: DollarSign, moduleKey: "referrals" },
          { to: "/app/referrals/invites", label: "Invites", icon: UserPlus, moduleKey: "referrals" },
          { to: "/app/referrals/leaderboard", label: "Leaderboard", icon: Trophy, moduleKey: "referrals" },
        ],
      },
    ],
  },
  {
    key: "account",
    label: "Account",
    icon: Settings,
    items: [
      { to: "/app/kyc", label: "Verification", icon: ShieldCheck, moduleKey: "kyc_verification" },
      { to: "/app/security", label: "Security", icon: Shield },
      { to: "/app/settings", label: "Settings", icon: Settings },
      { to: "/app/support", label: "Support", icon: LifeBuoy, moduleKey: "support_tickets" },

    ],
  },
  {
    key: "tools",
    label: "Tools",
    icon: Code,
    items: [
      { to: "/app/developer", label: "Developer", icon: Code, moduleKey: "developer" },
      { to: "/app/team", label: "Team", icon: Users, moduleKey: "team" },
    ],
  },
];

/**
 * Route matching for sidebar items. Items may carry a query string
 * (e.g. "/app/wallets?tab=fiat"); those only match when the tab param matches too.
 */
export function isSidebarItemActive(to: string, pathname: string, search = ""): boolean {
  const [path, query] = to.split("?");
  if (!pathname.startsWith(path)) return false;
  const currentTab = new URLSearchParams(search).get("tab");
  const targetTab = query ? new URLSearchParams(query).get("tab") : null;
  if (targetTab) return currentTab === targetTab;
  return true;
}
